import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

/**
 * This function renders the Sitemap page
 * @component SitemapPage
 * @return {Component} SitemapPage component
 */
export default function SitemapPage() {
  return (
    <Card style={{
      padding: '50px',
      width: '1200px',
      margin: '30px',
    }}>
      <Grid item xs={12} md={8}>
        <Typography variant="h6" gutterBottom>
          <h1>Sitemap</h1>
        </Typography>
        <Divider />
        <p style={{fontSize: '16px'}}>
            ...
        </p>
      </Grid>
    </Card>
  );
}
